import tAsString from "@/helpers/handleTranslate";
import { AnchorButton } from "@wivenn/wivenn-shared-visual-components";

export default function ErrorLayout({
  errorMessage,
}: {
  errorMessage?: string;
}) {
  return (
    <div className="h-screen w-screen bg-purple-radial text-WhiteWivenn flex justify-center items-center px-4">
      <div className="text-center items-center flex flex-col gap-y-10">
        <span className="text-7xl md:text-8xl text-orange-500">
          {tAsString("error")}...
        </span>
        <p className="text-lg md:text-xl font-medium">
          {tAsString("error_in_debug_panel")}
        </p>
        {errorMessage && (
          <p className="break-all break-words">{errorMessage}</p>
        )}
        <div className="flex flex-col gap-3 w-full max-w-96">
          <AnchorButton
            primary={false}
            value={tAsString("reload")}
            whiteVariation
            onClick={() => {
              window.location.reload();
            }}
          />
          <AnchorButton
            anchor="/"
            primary={false}
            value={tAsString("go_back_home")}
            whiteVariation
          />
        </div>
      </div>
    </div>
  );
}
